<template>
    <div>
        <p style="text-align: center">{{msg}}</p>
    </div>
</template>


<script>
export default {
    data () {
        return {
            msg: null
        }
    },
    computed: {
        apiStatus () {
            return this.$store.state.auth.apiStatus
        },
    },
    methods: {
        async completeRegister () {
            const path = this.$route.path.split('/')
            await this.$store.dispatch('auth/completeRegister', path[2])

            if (this.apiStatus) {
                // トップページに移動する
                this.$router.push('/')
            } else {
                this.msg = '認証に失敗しました。再度ご登録いただきますようお願いします。'
            }

        }
    },
    created () {
        this.completeRegister()
    }
}
</script>